import type { RedirectRequest } from "@azure/msal-browser";
import { getAuthScopes } from "./auth-scopes";

export const createLoginRequest = (configuredScopes: string | undefined): RedirectRequest => ({
	scopes: getAuthScopes(configuredScopes),
});
